import {apiSlice} from "../apiSlice";
import {UpdateRestaurantCommissionItem} from "../commissionSlice";

const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PROD;

export interface DeleteCartItem {
    restaurantId: string;
    cartId: string;
}

export const CommissionService = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getCommissionsForRestaurant: builder.query({
            query: (restaurantId) =>
                `https://adminhttps-getcommissionsforrestaurant${API_BASE_DOMAIN}?restaurantId=${restaurantId}`,
        }),

        updateRestaurantCommission: builder.mutation<void, UpdateRestaurantCommissionItem>({
            query: (data) => ({
                url: `https://adminhttps-updatecommissionsforrestaurant${API_BASE_DOMAIN}/`,
                method: "PUT",
                body: data,
                responseHandler: (response) => response.text(),
            }),
        }),
        deleteCartCommission: builder.mutation<any, DeleteCartItem>({
            query: (data: DeleteCartItem) => ({
                url: `https://adminhttps-deleterestaurantcartcommission${API_BASE_DOMAIN}`,
                method: "DELETE",
                body: data,
                responseHandler: (response) => response.text(),
            }),
        }),
    }),
});

export const {
    useUpdateRestaurantCommissionMutation,
    useGetCommissionsForRestaurantQuery,
    useLazyGetCommissionsForRestaurantQuery,
    useDeleteCartCommissionMutation
} = CommissionService;
